<template>
    <div class="pc__input_select" :class="stateObj">
        <label><slot name="label"></slot></label>
        <select :name="name" :value="value" ref="select" v-on:change="event_Change" v-on:focus="event_Focus" v-on:blur="event_Blur">
            <option v-for="option in options" v-bind:value="option.value">
                {{ option.text }}
            </option>
        </select>
    </div>
</template>

<script>

    export default {
        name: "pc-input-select",
        props: {
            options: Array,
            name: String,
            value: String
        },
        data(){
            return {
                stateObj : {
                    focused: false,
                    hasValue: false
                }
            }
        },
        mounted(){
            this.checkHasValue()
        },
        methods: {
            event_Change(){
                this.checkHasValue()
                this.$emit("changed", this.$refs.select.value)
            },
            event_Focus(e){
                this.stateObj.focused = true
            },
            event_Blur(e){
                this.stateObj.focused = false
            },
            checkHasValue(){
                this.stateObj.hasValue = (this.$refs.select.value != "")
            }
        }
    }

</script>

<style lang="scss">

    @import "../../../../common/css/mixins";

    .pc__input_select{

        background-color: #fff;
        @include prefix(border-radius, 5px);
        border: 1px solid #B1B3B3;
        height: auto;
        $transition: border-color .25s;
        @include prefix(transition, $transition);

        select{
            padding: 1.3rem .5rem .3rem .5rem;
            border: none;
            background: none;
            background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20width%3D%2215%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%209.1%205.3%22%20enable-background%3D%22new%200%200%209.1%205.3%22%20xml%3Aspace%3D%22preserve%22%3E%3Cg%3E%3Cpath%20fill%3D%22%23000%22%20d%3D%22M9.1%2C0.7L4.6%2C5.3L0%2C0.7L0.7%2C0l3.8%2C3.8L8.4%2C0L9.1%2C0.7z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E");
            background-position: 94% center;
            background-repeat: no-repeat;
            background-size: 15px auto;
            @include prefix(appearance, none);

            &:focus{
                background-color: transparent;
            }
            &::-ms-expand {
                display: none;
            }

        }

        label{
            $transition: margin-top 0.25s, font-size 0.25s;
            @include prefix(transition, $transition);
            position: absolute;
            margin-top: 11px;
            margin-left: 10px;
            color: #B1B3B3;
            z-index: 9;
            font-size: 1rem;
        }

        &.focused{
            @include prefix(box-shadow, 0 0 0 0.2rem rgba(0,123,255,.25))
        }

        &.focused,
        &.hasValue{
            label {
                margin-top: 4px;
                margin-left: 8px;
                font-size: .75rem;
            }
        }

    }
</style>